import React from 'react';

import cx from 'classnames';
import { config } from 'config';

import { Heading } from 'components/Heading';

import { API_VERSIONS } from '../../constants';
import AppleIcon from './apple.svg';
import GoogleIcon from './google.svg';

import s from './AddToCalendar.module.css';

type TProps = {
  appointmentGuid: string;
  source: string | undefined;
};

const AddToCalendar = ({ appointmentGuid, source }: TProps) => {
  const baseCalendarLink = `${
    config[API_VERSIONS.v3]
  }/appointments/${appointmentGuid}/`;
  const trackerParams = source
    ? `?utm_source=${encodeURIComponent(source)}`
    : '';

  return (
    <div className={cx(s.calendarContainer)}>
      <Heading as="h3" variant="small" className={s.calendarHeading}>
        Add to your calendar
      </Heading>

      <a
        target="_blank"
        rel="noreferrer"
        href={`${baseCalendarLink}gcal${trackerParams}`}
      >
        <GoogleIcon /> Google Calendar
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href={`${baseCalendarLink}ics${trackerParams}`}
      >
        <AppleIcon /> Calendar
      </a>
    </div>
  );
};

export default AddToCalendar;
